export default [
  // Put all routes here
  'home',
  'about',
  'templateContact',
  'templateFreesection',
]
